/* Mur d'avis : tri, filtres, répartition calculée, avis réels (genstack) et formulaire de dépôt.
   Sans dépendance, ES2019 (Safari iOS 14). Section sans data-api = rien ne se passe, le mur Liquid reste tel quel.
   Tout texte venu de l'API ou du client passe par textContent, jamais par innerHTML. */
(function () {
  'use strict';

  // Teintes = titres des variantes du produit (data-teintes, posé par la section), lues dans init().
  var TEINTES = [];
  // Clés (1re valeur) = catégories et modes de l'API genstack et des liens ?bw= : ne pas traduire.
  var PUCES = [['farbton', 'Shade'], ['halt', 'Hold & water'], ['anwendung', 'Application'], ['kopfhaut', 'Scalp'], ['lieferung', 'Delivery'], ['fotos', 'With photos']];
  var TRIS = [['empfohlen', 'Recommended'], ['neueste', 'Newest'], ['beste', 'Highest rated'], ['schlechteste', 'Lowest rated'], ['fotos', 'With photos first']];
  var CLE_JETONS = 'vyr_bew';
  var MSG = {
    merci: 'Thank you! We received your review.',
    attente: 'Only you can see this – under review',
    refuse: 'Only you can see this',
    vide: 'No reviews match this selection.',
    illisible: 'One photo could not be read and was left out.',
    trop: 'Up to 3 photos – the others were left out.',
    r429: 'Too many reviews in a short time. Please try again later.',
    ko: 'Something went wrong. Please try again.',
    etoiles: 'Please choose 1 to 5 stars.',
    nom: 'Please enter your first name and the first letter of your last name.',
    texte: 'Please write at least 10 characters.'
  };

  // ---------- logique pure (tests/vyran-reviews.test.mjs) ----------

  function parDate(a, b) { return a.date < b.date ? 1 : a.date > b.date ? -1 : 0; }

  // Les avis de l'auteur restent en tête ; « empfohlen » = épinglés dans l'ordre reçu (clés absentes ignorées), puis par date.
  function trier(items, mode, epingles) {
    var moi = [], autres = [], tete = [];
    items.forEach(function (x) { (x.moi ? moi : autres).push(x); });
    moi.sort(parDate);
    if (mode === 'empfohlen') {
      var parCle = {}, pris = {};
      autres.forEach(function (x) { parCle[x.cle] = x; });
      (epingles || []).forEach(function (k) {
        var x = Object.prototype.hasOwnProperty.call(parCle, k) ? parCle[k] : null;
        if (x && !pris[k]) { pris[k] = 1; tete.push(x); }
      });
      autres = autres.filter(function (x) { return !pris[x.cle]; });
    }
    var cmp = parDate;
    if (mode === 'beste') cmp = function (a, b) { return b.etoiles - a.etoiles || parDate(a, b); };
    else if (mode === 'schlechteste') cmp = function (a, b) { return a.etoiles - b.etoiles || parDate(a, b); };
    else if (mode === 'fotos') cmp = function (a, b) { return (b.photo ? 1 : 0) - (a.photo ? 1 : 0) || parDate(a, b); };
    return moi.concat(tete, autres.slice().sort(cmp));
  }

  // Le tri n'enlève rien ; le filtre, si. L'auteur voit toujours ses avis.
  function filtrer(items, f) {
    f = f || {};
    return items.filter(function (x) {
      if (x.moi) return true;
      if (f.etoiles && x.etoiles !== f.etoiles) return false;
      if (f.teinte && x.farbton !== f.teinte) return false;
      if (f.sujet === 'fotos') return !!x.photo;
      if (f.sujet && (x.sujets || []).indexOf(f.sujet) < 0) return false;
      return true;
    });
  }

  // Ce que tout le monde voit : l'avis non publié de l'auteur ne compte pas.
  function publics(items) { return items.filter(function (x) { return !(x.moi && x.statut !== 'publie'); }); }

  function repartition(items) {
    var r = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0, total: 0 };
    publics(items).forEach(function (x) {
      if (x.etoiles >= 1 && x.etoiles <= 5) { r[x.etoiles]++; r.total++; }
    });
    return r;
  }

  function moyenne(items) {
    var p = publics(items).filter(function (x) { return x.etoiles >= 1 && x.etoiles <= 5; });
    if (!p.length) return '–';
    var s = 0;
    p.forEach(function (x) { s += x.etoiles; });
    return (Math.round((s / p.length) * 10) / 10).toFixed(1);
  }

  function fusion(mur, api) {
    var cats = (api && api.mur) || {};
    var out = mur.map(function (x) {
      var c = Object.prototype.hasOwnProperty.call(cats, x.cle) && Array.isArray(cats[x.cle]) ? cats[x.cle].slice() : (x.sujets || []);
      return Object.assign({}, x, { sujets: c });
    });
    ((api && api.avis) || []).forEach(function (a) {
      var n = Number(a.photos) || 0;
      out.push({
        cle: 'id:' + a.id, id: a.id, etoiles: Number(a.etoiles) || 0, nom: String(a.nom || ''), date: String(a.date || ''),
        texte: String(a.texte || ''), photo: n > 0, photos: n, sujets: Array.isArray(a.sujets) ? a.sujets.slice() : [],
        farbton: a.farbton || null, source: 'client', moi: !!a.moi, statut: a.statut || 'publie', verifie: !!a.verifie, el: null
      });
    });
    return out;
  }

  // ---------- outils DOM ----------

  function pad(n) { return (n < 10 ? '0' : '') + Number(n); }
  // Date d'un avis du mur Liquid → ISO (tri). Accepte « Oct 13, 2026 », « 10/13/2026 », « 2026-10-13 », « 13.10.2026 ».
  function isoDe(d) {
    var s = String(d || '').trim(), m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
    if (m) return m[1] + '-' + m[2] + '-' + m[3];
    m = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(s);
    if (m) return m[3] + '-' + pad(m[2]) + '-' + pad(m[1]);
    var t = Date.parse(s);
    if (isNaN(t)) return '';
    var x = new Date(t);
    return x.getFullYear() + '-' + pad(x.getMonth() + 1) + '-' + pad(x.getDate());
  }
  // ISO → affichage US : « Oct 13, 2026 »
  var MOIS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function deDe(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
    return m ? MOIS[parseInt(m[2], 10) - 1] + ' ' + parseInt(m[3], 10) + ', ' + m[1] : '';
  }
  function aujourdhui() { var d = new Date(); return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
  function el(tag, cls, texte) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (texte !== undefined) e.textContent = texte;
    return e;
  }
  var SVG = 'http://www.w3.org/2000/svg';
  var ETOILE = 'M12 2.6l2.9 6.05 6.6.88-4.82 4.6 1.2 6.57L12 17.5 6.12 20.7l1.2-6.57L2.5 9.53l6.6-.88z';
  function etoile(pleine, cls) {
    var s = document.createElementNS(SVG, 'svg');
    s.setAttribute('class', cls || 'vyr-ra__star');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('aria-hidden', 'true');
    s.style.color = 'var(--vyr-star)'; // palette : layout/theme.liquid
    if (pleine) s.setAttribute('fill', 'currentColor');
    else { s.setAttribute('fill', 'none'); s.setAttribute('stroke', 'currentColor'); s.setAttribute('stroke-width', '1.8'); s.setAttribute('stroke-linejoin', 'round'); }
    var p = document.createElementNS(SVG, 'path');
    p.setAttribute('d', ETOILE);
    s.appendChild(p);
    return s;
  }

  // Jetons de l'auteur : [{ id, j }] dans localStorage. Navigation privée Safari = rien de lu, rien d'écrit, aucune exception.
  function lireJetons() {
    try {
      var v = JSON.parse(window.localStorage.getItem(CLE_JETONS) || '[]');
      if (!Array.isArray(v)) return [];
      return v.map(function (x) { return typeof x === 'string' ? { id: null, j: x } : x; })
        .filter(function (x) { return x && typeof x.j === 'string' && /^[A-Za-z0-9_-]{16,128}$/.test(x.j); });
    } catch (e) { return []; }
  }
  function garderJeton(id, j) {
    try {
      var v = lireJetons().filter(function (x) { return x.j !== j; });
      v.unshift({ id: id, j: j });
      window.localStorage.setItem(CLE_JETONS, JSON.stringify(v.slice(0, 20)));
    } catch (e) { /* stockage indisponible : l'avis reste visible jusqu'au rechargement */ }
  }

  function delai(ms) {
    var c = typeof AbortController === 'function' ? new AbortController() : null;
    var t = setTimeout(function () { if (c) c.abort(); }, ms);
    return { signal: c ? c.signal : undefined, fin: function () { clearTimeout(t); } };
  }

  // Photo → JPEG ≤ 1 600 px (côté le plus long), qualité 0,82. Passe par <img> : décode le HEIC sur iPhone,
  // applique l'orientation EXIF, et marche sur iOS 14 (pas de createImageBitmap avant Safari 15).
  function versJpeg(canvas, q) {
    return new Promise(function (ok, ko) {
      canvas.toBlob(function (b) { if (b) ok(b); else ko(new Error('toBlob')); }, 'image/jpeg', q);
    });
  }
  function reduire(fichier) {
    return new Promise(function (ok, ko) {
      var url = URL.createObjectURL(fichier);
      var img = new Image();
      img.onload = function () {
        try {
          var w = img.naturalWidth, h = img.naturalHeight;
          if (!w || !h) throw new Error('image vide');
          var k = Math.min(1, 1600 / Math.max(w, h));
          var c = document.createElement('canvas');
          c.width = Math.max(1, Math.round(w * k));
          c.height = Math.max(1, Math.round(h * k));
          var g = c.getContext('2d');
          g.fillStyle = '#fff';
          g.fillRect(0, 0, c.width, c.height);
          g.drawImage(img, 0, 0, c.width, c.height);
          URL.revokeObjectURL(url);
          versJpeg(c, 0.82).then(function (b) { return b.size > 1900000 ? versJpeg(c, 0.6) : b; }).then(ok, ko);
        } catch (e) { URL.revokeObjectURL(url); ko(e); }
      };
      img.onerror = function () { URL.revokeObjectURL(url); ko(new Error('illisible')); };
      img.src = url;
    });
  }

  // ---------- le mur ----------

  // Lien profond pour le SAV : ?bw=kopfhaut · ?bw=2 · ?bw=schlechteste · ?bw=hellbraun, combinables (?bw=2,kopfhaut).
  function lireLien(search) {
    var m = /[?&]bw=([^&#]*)/.exec(String(search || ''));
    var r = {};
    if (!m) return r;
    decodeURIComponent(m[1].replace(/\+/g, ',')).split(',').forEach(function (brut) {
      var t = brut.trim().toLowerCase();
      if (!t) return;
      if (/^[1-5]$/.test(t)) { r.etoiles = parseInt(t, 10); return; }
      if (['empfohlen', 'neueste', 'beste', 'schlechteste'].indexOf(t) >= 0) { r.mode = t; return; }
      if (PUCES.some(function (p) { return p[0] === t; })) { r.sujet = t; return; }
      TEINTES.forEach(function (x) { if (x.toLowerCase() === t) r.teinte = x; });
    });
    return r;
  }

  function init(root) {
    if (!root || root.dataset.vyrWall === '1') return;
    var api = String(root.dataset.api || '').trim().replace(/\/+$/, '');
    if (!api) return;
    var liste = root.querySelector('.vyr-ra__list');
    var outils = root.querySelector('[data-vyr-ratools]');
    if (!liste || !outils) return;
    root.dataset.vyrWall = '1';

    var produit = root.dataset.produit || '';
    var projet = root.dataset.projet || '';
    TEINTES = String(root.dataset.teintes || '').split('|').filter(function (t) { return t; });
    var visible = parseInt(root.dataset.visible, 10) || 6;
    var libVerifie = root.dataset.verified || 'Verified';
    var etat = { mode: 'empfohlen', etoiles: null, teinte: null, sujet: null, montres: visible };
    var epingles = [];
    var apiOk = false;
    var jetons = lireJetons();

    var items = [].map.call(root.querySelectorAll('.vyr-ra__item[data-cle]'), function (e) {
      var n = e.querySelector('.vyr-ra__name');
      return {
        cle: e.dataset.cle, etoiles: parseInt(e.dataset.stars, 10) || 0, nom: n ? n.textContent : '', date: isoDe(e.dataset.date),
        texte: '', photo: e.dataset.photo === '1', sujets: [], farbton: null, source: 'mur', moi: false, statut: 'publie', verifie: true, el: e
      };
    });

    // « Show more » : rendu par Liquid quand le mur est branché ; l'ancien gestionnaire s'efface (data-vyr-wall).
    var plusLigne = root.querySelector('.vyr-ra__morerow');
    if (!plusLigne) {
      plusLigne = el('div', 'vyr-ra__morerow');
      plusLigne.appendChild(el('button', 'vyr-ra__showmore', 'Show more')).type = 'button';
      liste.appendChild(plusLigne);
    }
    var plus = plusLigne.querySelector('button');
    plus.addEventListener('click', function () { etat.montres += 12; rendre(); });

    // Barre d'outils : tri, teinte, puces, remise à zéro.
    outils.textContent = '';
    function choix(libelle, options, cls) {
      var w = el('label', 'vyr-ra__sel ' + cls);
      w.appendChild(el('span', 'vyr-ra__sellab', libelle));
      var s = el('select', 'vyr-ra__select');
      options.forEach(function (o) { var op = el('option', '', o[1]); op.value = o[0]; s.appendChild(op); });
      w.appendChild(s);
      return { w: w, s: s };
    }
    var tri = choix('Sort by', TRIS, 'vyr-ra__sel--tri');
    var teinte = choix('Your shade', [['', 'All']].concat(TEINTES.map(function (t) { return [t, t]; })), 'vyr-ra__sel--teinte');
    teinte.w.hidden = true;
    var ligne = el('div', 'vyr-ra__toolrow');
    ligne.appendChild(tri.w);
    ligne.appendChild(teinte.w);
    outils.appendChild(ligne);
    var puces = el('div', 'vyr-ra__chips');
    puces.setAttribute('role', 'group');
    puces.setAttribute('aria-label', 'Topics');
    puces.hidden = true;
    var boutonsPuces = {};
    PUCES.forEach(function (p) {
      var b = el('button', 'vyr-ra__chip');
      b.type = 'button';
      b.setAttribute('aria-pressed', 'false');
      b.appendChild(el('span', '', p[1]));
      b.appendChild(el('span', 'vyr-ra__chipn', ''));
      b.hidden = true;
      b.addEventListener('click', function () { etat.sujet = etat.sujet === p[0] ? null : p[0]; etat.montres = visible; rendre(); });
      boutonsPuces[p[0]] = b;
      puces.appendChild(b);
    });
    outils.appendChild(puces);
    var raz = el('button', 'vyr-ra__reset', 'Clear filters');
    raz.type = 'button';
    raz.hidden = true;
    raz.addEventListener('click', function () {
      etat.etoiles = null; etat.teinte = null; etat.sujet = null; etat.montres = visible;
      teinte.s.value = '';
      rendre();
    });
    outils.appendChild(raz);
    var vide = el('p', 'vyr-ra__empty', MSG.vide);
    vide.hidden = true;
    outils.parentNode.insertBefore(vide, outils.nextSibling);

    var lien = lireLien(location.search);
    Object.keys(lien).forEach(function (k) { etat[k] = lien[k]; });
    tri.s.value = etat.mode;
    if (etat.teinte) teinte.s.value = etat.teinte;
    tri.s.addEventListener('change', function () { etat.mode = tri.s.value; etat.montres = visible; rendre(); });
    teinte.s.addEventListener('change', function () { etat.teinte = teinte.s.value || null; etat.montres = visible; rendre(); });

    // Répartition : les barres deviennent des filtres (2e clic = retiré).
    var barres = [].slice.call(root.querySelectorAll('[data-vyr-rabar]'));
    barres.forEach(function (b) {
      b.addEventListener('click', function () {
        var s = parseInt(b.getAttribute('data-vyr-rabar'), 10);
        etat.etoiles = etat.etoiles === s ? null : s;
        etat.montres = visible;
        rendre();
      });
    });
    var note = root.querySelector('[data-vyr-ranum]');
    var totalEl = root.querySelector('[data-vyr-ratotal]');

    function compteurs() {
      var r = repartition(items);
      barres.forEach(function (b) {
        var s = parseInt(b.getAttribute('data-vyr-rabar'), 10);
        var c = r[s] || 0;
        var f = b.querySelector('.vyr-ra__fill');
        var n = b.querySelector('.vyr-ra__barc');
        // au moins 1 % dès qu'un avis existe : une barre vide se lit « 0 » (1 avis sur 105 = 0,95 %)
        if (f) f.style.width = (r.total ? Math.max(c ? 1 : 0, Math.floor((c * 100) / r.total)) : 0) + '%';
        if (n) n.textContent = String(c);
        b.setAttribute('aria-label', s + (s === 1 ? ' star: ' : ' stars: ') + c + (c === 1 ? ' review' : ' reviews'));
        b.disabled = c === 0 && etat.etoiles !== s;
      });
      if (note) note.textContent = moyenne(items);
      if (totalEl) totalEl.textContent = String(r.total);
      var pub = publics(items);
      PUCES.forEach(function (p) {
        var n = pub.filter(function (x) { return p[0] === 'fotos' ? x.photo : (x.sujets || []).indexOf(p[0]) >= 0; }).length;
        boutonsPuces[p[0]].hidden = !apiOk || n === 0;
        boutonsPuces[p[0]].querySelector('.vyr-ra__chipn').textContent = String(n);
      });
      puces.hidden = !apiOk || PUCES.every(function (p) { return boutonsPuces[p[0]].hidden; });
      var parTeinte = {};
      pub.forEach(function (x) { if (x.farbton) parTeinte[x.farbton] = (parTeinte[x.farbton] || 0) + 1; });
      [].forEach.call(teinte.s.options, function (o) {
        if (!o.value) return;
        var n = parTeinte[o.value] || 0;
        o.textContent = o.value + ' (' + n + ')';
        o.disabled = n === 0 && etat.teinte !== o.value;
      });
      teinte.w.hidden = !Object.keys(parTeinte).length && !etat.teinte;
    }

    function rendre() {
      var tries = trier(items, etat.mode, epingles);
      var garde = filtrer(tries, etat);
      var ok = {};
      garde.forEach(function (x) { ok[x.cle] = 1; });
      var n = 0;
      tries.forEach(function (x) {
        if (!x.el) return;
        liste.insertBefore(x.el, plusLigne);
        var montre = !!ok[x.cle] && n < etat.montres;
        if (ok[x.cle]) n++;
        x.el.classList.toggle('is-hidden', !montre);
      });
      plusLigne.hidden = garde.length <= etat.montres;
      plus.style.display = '';
      vide.hidden = garde.length > 0;
      raz.hidden = !(etat.etoiles || etat.teinte || etat.sujet);
      barres.forEach(function (b) {
        var s = parseInt(b.getAttribute('data-vyr-rabar'), 10);
        b.setAttribute('aria-pressed', etat.etoiles === s ? 'true' : 'false');
        b.classList.toggle('is-dim', !!etat.etoiles && etat.etoiles !== s);
      });
      PUCES.forEach(function (p) { boutonsPuces[p[0]].setAttribute('aria-pressed', etat.sujet === p[0] ? 'true' : 'false'); });
    }

    function jetonDe(id) {
      for (var i = 0; i < jetons.length; i++) if (jetons[i].id === id) return jetons[i].j;
      return jetons.length === 1 ? jetons[0].j : null;
    }

    // Même balisage que snippets/vyran-review-item.liquid.
    function carte(x, jeton, urlsLocales) {
      var a = el('article', 'vyr-ra__item vyr-ra__item--client' + (x.moi ? ' vyr-ra__item--moi' : ''));
      a.setAttribute('data-cle', x.cle);
      var st = el('span', 'vyr-ra__stars');
      st.setAttribute('aria-label', x.etoiles + ' out of 5');
      for (var s = 1; s <= 5; s++) st.appendChild(etoile(s <= x.etoiles));
      a.appendChild(st);
      var who = el('div', 'vyr-ra__who');
      var av = el('span', 'vyr-ra__av vyr-ra__av--ltr', Array.from(x.nom)[0] || '');
      av.setAttribute('aria-hidden', 'true');
      who.appendChild(av);
      var meta = el('span', 'vyr-ra__meta');
      var l1 = el('span', 'vyr-ra__line1');
      l1.appendChild(el('span', 'vyr-ra__name', x.nom));
      if (x.verifie) l1.appendChild(el('span', 'vyr-ra__vpill', libVerifie));
      meta.appendChild(l1);
      meta.appendChild(el('span', 'vyr-ra__date', deDe(x.date)));
      who.appendChild(meta);
      a.appendChild(who);
      if (x.farbton) a.appendChild(el('p', 'vyr-ra__shade', 'Shade: ' + x.farbton));
      var body = el('div', 'vyr-ra__body');
      body.appendChild(el('p', 'vyr-ra__txt vyr-ra__txt--api', x.texte));
      a.appendChild(body);
      var urls = urlsLocales || [];
      if (!urlsLocales) {
        for (var n = 0; n < Math.min(3, x.photos || 0); n++) {
          urls.push(api + '/api/public/bewertung-foto/' + encodeURIComponent(x.id) + '/' + n + (x.moi && jeton ? '?j=' + encodeURIComponent(jeton) : ''));
        }
      }
      if (urls.length) {
        var pics = el('div', 'vyr-ra__pics');
        urls.forEach(function (u) {
          var im = el('img', 'vyr-ra__pic');
          im.src = u;
          im.alt = 'Photo from ' + x.nom;
          im.loading = 'lazy';
          im.decoding = 'async';
          im.onerror = function () { im.remove(); };
          pics.appendChild(im);
        });
        a.appendChild(pics);
      }
      if (x.moi && x.statut !== 'publie') a.appendChild(el('p', 'vyr-ra__mine', x.statut === 'refuse' ? MSG.refuse : MSG.attente));
      return a;
    }

    function charger() {
      var h = {};
      if (jetons.length) h['X-Vyr-Jetons'] = jetons.map(function (x) { return x.j; }).join(',');
      var d = delai(4000);
      fetch(api + '/api/public/bewertungen?projet=' + encodeURIComponent(projet) + '&produit=' + encodeURIComponent(produit), { headers: h, signal: d.signal })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (j) {
          d.fin();
          if (!j || !Array.isArray(j.avis)) throw new Error('réponse inattendue');
          var neufs = fusion(items.filter(function (x) { return x.source === 'mur'; }), j);
          neufs.forEach(function (x) { if (x.source === 'client') x.el = carte(x, jetonDe(x.id)); });
          var locaux = items.filter(function (x) { return x.local; }).filter(function (l) {
            var double = neufs.some(function (x) { return x.cle === l.cle; });
            if (double && l.el) l.el.remove();
            return !double;
          });
          items = locaux.concat(neufs);
          epingles = Array.isArray(j.epingles) ? j.epingles.map(String) : [];
          apiOk = true;
          compteurs();
          rendre();
          if (Object.keys(lien).length) root.scrollIntoView({ block: 'start' });
        })
        .catch(function () { d.fin(); /* API injoignable ou lente : le mur Liquid reste, tri et étoiles marchent */ });
    }

    // ---------- formulaire ----------
    var cta = root.querySelector('[data-vyr-rawrite]');
    var merci = null, dlg = null;
    if (cta) {
      merci = el('p', 'vyr-ra__thanks');
      merci.setAttribute('role', 'status');
      merci.hidden = true;
      cta.parentNode.insertBefore(merci, cta.nextSibling);
      cta.addEventListener('click', function (e) { e.preventDefault(); ouvrir(); });
    }

    var f = {};   // éléments du formulaire
    var fotos = []; // [{ blob, url }]
    var lecture = 0;

    function construire() {
      if (dlg) return;
      dlg = el('dialog', 'vyr-rf');
      dlg.setAttribute('aria-labelledby', 'vyr-rf-titre');
      var form = el('form', 'vyr-rf__form');
      form.noValidate = true;
      var tete = el('div', 'vyr-rf__head');
      var h = el('h3', 'vyr-rf__h', (cta && cta.textContent.trim()) || 'Write a review');
      h.id = 'vyr-rf-titre';
      tete.appendChild(h);
      var x = el('button', 'vyr-rf__x', '×');
      x.type = 'button';
      x.setAttribute('aria-label', 'Close');
      x.addEventListener('click', fermer);
      tete.appendChild(x);
      form.appendChild(tete);

      var fs = el('fieldset', 'vyr-rf__stars');
      fs.appendChild(el('legend', 'vyr-rf__lab', 'How would you rate it?'));
      var rang = el('div', 'vyr-rf__starrow');
      f.radios = [];
      for (var s = 1; s <= 5; s++) {
        var lab = el('label', 'vyr-rf__star');
        var r = el('input', 'vyr-rf__sr');
        r.type = 'radio'; r.name = 'etoiles'; r.value = String(s);
        r.setAttribute('aria-label', s + (s === 1 ? ' star' : ' stars'));
        lab.appendChild(r);
        lab.appendChild(etoile(false, 'vyr-rf__svg'));
        rang.appendChild(lab);
        f.radios.push(r);
      }
      rang.addEventListener('change', peindreEtoiles);
      fs.appendChild(rang);
      form.appendChild(fs);

      function champ(libelle, input, aide) {
        var w = el('label', 'vyr-rf__field');
        w.appendChild(el('span', 'vyr-rf__lab', libelle));
        w.appendChild(input);
        if (aide) w.appendChild(aide);
        form.appendChild(w);
        return input;
      }
      f.nom = el('input', 'vyr-rf__in');
      f.nom.name = 'nom'; f.nom.maxLength = 60; f.nom.autocomplete = 'given-name';
      champ('First name and last initial', f.nom);
      f.texte = el('textarea', 'vyr-rf__in vyr-rf__ta');
      f.texte.name = 'texte'; f.texte.maxLength = 2000; f.texte.rows = 5;
      f.compte = el('span', 'vyr-rf__count', '0 / 2,000 characters (min. 10)');
      f.texte.addEventListener('input', function () { f.compte.textContent = f.texte.value.length + ' / 2,000 characters (min. 10)'; });
      champ('Your experience', f.texte, f.compte);
      f.teinte = el('select', 'vyr-rf__in');
      f.teinte.name = 'farbton';
      [['', '–']].concat(TEINTES.map(function (t) { return [t, t]; })).forEach(function (o) { var op = el('option', '', o[1]); op.value = o[0]; f.teinte.appendChild(op); });
      champ('Which shade did you buy? (optional)', f.teinte);
      // Champ natif masqué (il afficherait « Aucun fichier choisi » dans la langue du navigateur) ; le libellé l'ouvre.
      f.fichier = el('input', 'vyr-rf__file');
      f.fichier.type = 'file'; f.fichier.accept = 'image/*'; f.fichier.multiple = true;
      var choisir = f.choisir = el('span', 'vyr-rf__pick', 'Choose photos');
      choisir.setAttribute('aria-hidden', 'true');
      f.apercus = el('div', 'vyr-rf__thumbs');
      champ('Photos (optional, up to 3)', f.fichier, choisir);
      form.appendChild(f.apercus);
      f.fichier.addEventListener('change', ajouterFotos);
      f.commande = el('input', 'vyr-rf__in');
      f.commande.name = 'commande'; f.commande.maxLength = 20; f.commande.inputMode = 'numeric'; f.commande.autocomplete = 'off';
      champ('Order number (optional) – it is in your order confirmation email', f.commande);
      var piege = el('div', 'vyr-rf__hp');
      piege.setAttribute('aria-hidden', 'true');
      f.piege = el('input');
      f.piege.name = 'website'; f.piege.tabIndex = -1; f.piege.autocomplete = 'off';
      piege.appendChild(f.piege);
      form.appendChild(piege);
      f.note = el('p', 'vyr-rf__note');
      f.note.setAttribute('aria-live', 'polite');
      form.appendChild(f.note);
      f.msg = el('p', 'vyr-rf__msg');
      f.msg.setAttribute('role', 'alert');
      form.appendChild(f.msg);
      f.envoyer = el('button', 'vyr-rf__send', 'Submit');
      f.envoyer.type = 'submit';
      form.appendChild(f.envoyer);
      form.addEventListener('submit', envoyer);
      form.addEventListener('input', function () { if (f.msg.textContent) erreur(''); });
      form.addEventListener('change', function (e) { if (e.target !== f.fichier && f.msg.textContent) erreur(''); });
      f.form = form;
      dlg.appendChild(form);
      dlg.addEventListener('close', nettoyer);
      dlg.addEventListener('cancel', function () { setTimeout(nettoyer, 0); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) fermer(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && dlg.hasAttribute('open') && dlg.classList.contains('is-fallback')) fermer(); });
      document.body.appendChild(dlg);
    }

    function peindreEtoiles() {
      var v = valeurEtoiles();
      f.radios.forEach(function (r, i) { r.parentNode.classList.toggle('is-on', i < v); });
    }
    function valeurEtoiles() {
      for (var i = 0; i < f.radios.length; i++) if (f.radios[i].checked) return i + 1;
      return 0;
    }

    function ouvrir() {
      construire();
      merci.hidden = true;
      if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); }
      else { dlg.setAttribute('open', ''); dlg.classList.add('is-fallback'); }
      document.documentElement.setAttribute('scroll-lock', '');
      var cible = f.radios[Math.max(0, valeurEtoiles() - 1)];
      try { cible.focus({ preventScroll: true }); } catch (e) { cible.focus(); }
    }
    function fermer() {
      if (!dlg) return;
      if (typeof dlg.close === 'function' && dlg.open) dlg.close();
      else dlg.removeAttribute('open');
      nettoyer();
    }
    function nettoyer() {
      document.documentElement.removeAttribute('scroll-lock');
      if (cta && dlg && !dlg.hasAttribute('open')) { try { cta.focus({ preventScroll: true }); } catch (e) { /* rien */ } }
    }

    function apercus() {
      f.apercus.textContent = '';
      fotos.forEach(function (p, i) {
        var w = el('span', 'vyr-rf__thumb');
        var im = el('img');
        im.src = p.url; im.alt = 'Photo ' + (i + 1);
        w.appendChild(im);
        var x = el('button', 'vyr-rf__rm', '×');
        x.type = 'button';
        x.setAttribute('aria-label', 'Remove photo ' + (i + 1));
        x.addEventListener('click', function (e) {
          e.preventDefault();
          URL.revokeObjectURL(p.url);
          fotos.splice(fotos.indexOf(p), 1);
          f.note.textContent = '';
          apercus();
        });
        w.appendChild(x);
        f.apercus.appendChild(w);
      });
      f.fichier.disabled = fotos.length >= 3;
      f.choisir.hidden = fotos.length >= 3;
    }

    function ajouterFotos() {
      var liste = [].slice.call(f.fichier.files || []);
      f.fichier.value = '';
      var notes = [];
      var place = 3 - fotos.length - lecture;
      if (liste.length > place) { notes.push(MSG.trop); liste = liste.slice(0, Math.max(0, place)); }
      if (!liste.length) { f.note.textContent = notes.join(' '); return; }
      lecture += liste.length;
      f.envoyer.disabled = true;
      var chaine = Promise.resolve();
      var illisible = false;
      liste.forEach(function (fichier) {
        chaine = chaine.then(function () {
          return reduire(fichier).then(function (b) {
            fotos.push({ blob: b, url: URL.createObjectURL(b) });
          }, function () { illisible = true; });
        }).then(function () { lecture--; });
      });
      chaine.then(function () {
        if (illisible) notes.push(MSG.illisible);
        f.note.textContent = notes.join(' ');
        f.envoyer.disabled = false;
        apercus();
      });
    }

    function erreur(m) { f.msg.textContent = m; }

    function envoyer(e) {
      e.preventDefault();
      if (f.envoyer.disabled) return;
      var etoiles = valeurEtoiles();
      var nom = f.nom.value.trim();
      var texte = f.texte.value.trim();
      if (!etoiles) { erreur(MSG.etoiles); f.radios[0].focus(); return; }
      if (!nom) { erreur(MSG.nom); f.nom.focus(); return; }
      if (texte.length < 10) { erreur(MSG.texte); f.texte.focus(); return; }
      erreur('');
      var fd = new FormData();
      fd.append('projet', projet);
      fd.append('produit', produit);
      fd.append('etoiles', String(etoiles));
      fd.append('nom', nom);
      fd.append('texte', texte);
      fd.append('farbton', f.teinte.value);
      fd.append('commande', f.commande.value.trim());
      fd.append('website', f.piege.value);
      var envoyees = fotos.slice(0, 3);
      envoyees.forEach(function (p, i) { fd.append('photo' + i, p.blob, 'foto' + i + '.jpg'); });
      f.envoyer.disabled = true;
      f.envoyer.textContent = 'Sending…';
      var d = delai(60000);
      fetch(api + '/api/public/bewertung', { method: 'POST', body: fd, signal: d.signal })
        .then(function (r) {
          return r.json().catch(function () { return null; }).then(function (j) { return { ok: r.ok, status: r.status, j: j }; });
        })
        .then(function (rep) {
          d.fin();
          if (!rep.ok || !rep.j || !rep.j.id || !rep.j.jeton) { erreur(rep.status === 429 ? MSG.r429 : MSG.ko); return; }
          reussi(rep.j, { etoiles: etoiles, nom: nom, texte: texte, farbton: f.teinte.value || null }, envoyees);
        })
        .catch(function () { d.fin(); erreur(MSG.ko); })
        .then(function () { f.envoyer.disabled = false; f.envoyer.textContent = 'Submit'; });
    }

    function reussi(rep, s, envoyees) {
      garderJeton(rep.id, rep.jeton);
      jetons = lireJetons();
      var x = {
        cle: 'id:' + rep.id, id: rep.id, etoiles: s.etoiles, nom: s.nom, date: aujourdhui(), texte: s.texte,
        photo: envoyees.length > 0, photos: envoyees.length, sujets: [], farbton: s.farbton, source: 'client',
        moi: true, statut: 'a_moderer', verifie: false, local: true
      };
      x.el = carte(x, null, envoyees.map(function (p) { return p.url; }));
      items.unshift(x);
      fotos = [];
      f.form.reset();
      f.compte.textContent = '0 / 2,000 characters (min. 10)';
      f.note.textContent = '';
      peindreEtoiles();
      apercus();
      fermer();
      merci.textContent = MSG.merci;
      merci.hidden = false;
      compteurs();
      rendre();
    }

    compteurs();
    rendre();
    charger();
  }

  window.VyrReviews = { trier: trier, filtrer: filtrer, repartition: repartition, moyenne: moyenne, fusion: fusion, lireLien: lireLien, init: init };
})();
